import { styled } from 'styled-components'

// Square because every book size is, same as the cart thumbnail. The top margin
// leaves the popup's close button its corner.
export const BookCover = styled.div`
  width: 148px;
  height: 148px;
  margin: 44px 0 20px;
`
